import Title from "./Title";
import { useEffect, useState } from "react";
import getNaverCommunityWebsite from "../apis/naverCommunity";
import TitleWithBookMark from "./TitleWithBookMark";
import styled from 'styled-components';
import { getGoogleWebsiteList } from "../apis/google";
import SeeMoreButton from "./SeeMoreButton";
import { useRecoilState } from 'recoil';
import LoginModal from '../components/LoginModal';
import { isLoginModalOpenState } from '../stores/authStore';
import { auth } from '../firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { addUser } from "../apis/analytics";

const SearchResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px 12px;
  border-bottom: 1px solid var(--Neutral-neutral5, #F2F2F2); /* Adjust styling as needed */
  // border-radius: 8px;
`;

const SearchResultHeader = styled.div`
  display: flex;
  align-items: center;
`;

const Favicon = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
`;

const Url = styled.span`
  font-size: 12px;
  color: var(--Main-deepBlue, #020c19);
  overflow: hidden;
`;

const TitleText = styled.div`
  font-size: 16px;
  color: #0057ff;
  padding-top: 12px;
`;

const Snippet = styled.div`
  font-size: 12px;
  padding-top: 8px;
  color: #4d4d4d;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;

const CommunityWrapper = styled.div`
    iframe{
        padding-left: 0px;
        padding-right: 0px;
        width: 100%;
        height: calc(100vh - 162px);
    }
`;

const SearchResult = ({ favicon, title, url, snippet, index }) => {
  return (
    <SearchResultContainer style={index === 0 ? {padding: '0px 12px 12px'} : {}}>
      <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
        <SearchResultHeader>
          <Favicon src={favicon} alt="favicon" />
          <Url>{url}</Url>
        </SearchResultHeader>
        <TitleText>{title}</TitleText>
        <Snippet>{snippet}</Snippet>
      </a>
    </SearchResultContainer>
  );
};

function Community() {
    const [isLoginModalOpen, setIsLoginModalOpen] = useRecoilState(isLoginModalOpenState);
    const urlSearch = new URLSearchParams(window.location.search);
    const [searchQuery, setSearchQuery] = useState(urlSearch.get('q') || '');
    const [searchResult, setSearchResult] = useState('');
    const [bookmark, setBookmark] = useState({
        type: 'community',
        query: searchQuery,
        isSeeMore: false
    });

    useEffect(() => {
        async function run() {
            const googleSearch = await getGoogleWebsiteList(searchQuery);
            setSearchResult(googleSearch);
        }

        if (searchQuery) {
            run();
        }
    }, [searchQuery]);

    const handleSignIn = async () => {
        const provider = new GoogleAuthProvider();
        try {
          const result = await signInWithPopup(auth, provider);
          addUser(result.user.uid);
          localStorage.setItem("user", result.user.uid);
        } catch (error) {
          console.error(error);
        }
      };

    return (
        <>
            <CommunityWrapper id="community">
                <TitleWithBookMark title={"Community"} bookmark={bookmark} />
                {searchResult && searchResult.slice(0, 3).map((item, index) => {
                    return <SearchResult key={index} favicon={item.favicon ? item.favicon : item.pagemap.cse_image ? item.pagemap.cse_image[0].src : '' } title={item.title} url={item.link} snippet={item.snippet} index={index}/>
                })}
                <SeeMoreButton path="community" />
            </CommunityWrapper>
            {isLoginModalOpen && <LoginModal handleClosePopup={() => setIsLoginModalOpen(false)} handleSignIn={handleSignIn} />}
        </>
    )
}

export default Community;
